export default __webpack_public_path__ + "static/media/nodejs_icon.fbd4f2f1.png";